import * as types from '@/constants/store-types'

export default {
  [types.SET_LOADING_PROGRESS](state, { type, progress }) {
    state.loadingProgress[type] = progress
  },
  [types.SET_OFFLINE](state, offline) {
    state.offline = offline
  },
  [types.SET_FINGERPRINT](state, fingerprint) {
    state.fingerprint = fingerprint
  },
  [types.SET_ACCOUNT](state, account) {
    state.account = account
  },
  [types.SET_STATUS](state, status) {
    state.status = status
  },
  [types.SET_CLIENT_TYPE](state, clientType) {
    state.clientType = clientType
  },
  [types.SET_MAP_OPTIONS](state, value) {
    state.mapOptions = value
  },
  [types.REFRESH_TOKEN](state, { accessToken, refreshToken }) {
    state.account.accessToken = accessToken
    state.account.refreshToken = refreshToken
  },
  [types.SET_AVAILABILITY](state, availability) {
    state.available = availability
  },
  [types.SET_WEB_VIEW](state, webView) {
    state.webView = webView
  }
}
